var exports = {
  "DF": "MainContent__hfTHMO",
  "Bx": "Sidebar__v6s6G8",
  "hE": "Title__hwJsPp",
};

module.exports = exports;
